// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";

let jsonCodec = Jzon.object6(param => [
  param.widthFront,
  param.widthBack,
  param.heightFront,
  param.heightBack,
  param.baseFrontExtra,
  param.baseBackExtra
], param => ({
  TAG: "Ok",
  _0: {
    widthFront: param[0],
    widthBack: param[1],
    heightFront: param[2],
    heightBack: param[3],
    baseFrontExtra: param[4],
    baseBackExtra: param[5]
  }
}), Jzon.field("widthFront", Jzon.float), Jzon.field("widthBack", Jzon.float), Jzon.field("heightFront", Jzon.float), Jzon.field("heightBack", Jzon.float), Jzon.field("baseFrontExtra", Jzon.float), Jzon.field("baseBackExtra", Jzon.float));

let AxesModelDimensions = {
  jsonCodec: jsonCodec
};

let options = [
  "VehicleBicycle",
  "VehicleScooter",
  "VehicleCar"
];

let jsonCodec$1 = LumiJzon.anySumAsString(options, undefined);

let VehicleClass = {
  options: options,
  jsonCodec: jsonCodec$1
};

let options$1 = [
  "GutterUpper",
  "GutterLower",
  "GutterAngled"
];

let jsonCodec$2 = LumiJzon.anySumAsString(options$1, undefined);

let GutterClass = {
  options: options$1,
  jsonCodec: jsonCodec$2
};

let values = [
  "PlaceClassUnclassified",
  "PlaceClassOther",
  {
    TAG: "PlaceClassGround",
    _0: "VehicleBicycle"
  },
  {
    TAG: "PlaceClassGround",
    _0: "VehicleScooter"
  },
  {
    TAG: "PlaceClassGround",
    _0: "VehicleCar"
  },
  {
    TAG: "PlaceClassGutter",
    _0: "GutterUpper"
  },
  {
    TAG: "PlaceClassGutter",
    _0: "GutterLower"
  },
  {
    TAG: "PlaceClassGutter",
    _0: "GutterAngled"
  },
  "PlaceClassWheelClamp",
  "PlaceClassStapleRack",
  "PlaceClassVertical",
  "PlaceClassHandlebarSuspension"
];

function stringCodec_toString(placeClass) {
  if (typeof placeClass !== "object") {
    switch (placeClass) {
      case "PlaceClassUnclassified" :
        return "Unclassified";
      case "PlaceClassOther" :
        return "Other";
      case "PlaceClassWheelClamp" :
        return "Wheel clamp";
      case "PlaceClassStapleRack" :
        return "Staple";
      case "PlaceClassVertical" :
        return "Vertical";
      case "PlaceClassHandlebarSuspension" :
        return "Handlebar suspension";
    }
  } else if (placeClass.TAG === "PlaceClassGround") {
    switch (placeClass._0) {
      case "VehicleBicycle" :
        return "Ground bicycle";
      case "VehicleScooter" :
        return "Ground scooter";
      case "VehicleCar" :
        return "Ground car";
    }
  } else {
    switch (placeClass._0) {
      case "GutterUpper" :
        return "Gutter upper";
      case "GutterLower" :
        return "Gutter lower";
      case "GutterAngled" :
        return "Gutter angled";
    }
  }
}

function stringCodec_fromString(str) {
  switch (str) {
    case "Ground bicycle" :
      return {
        TAG: "PlaceClassGround",
        _0: "VehicleBicycle"
      };
    case "Ground car" :
      return {
        TAG: "PlaceClassGround",
        _0: "VehicleCar"
      };
    case "Ground scooter" :
      return {
        TAG: "PlaceClassGround",
        _0: "VehicleScooter"
      };
    case "Gutter angled" :
      return {
        TAG: "PlaceClassGutter",
        _0: "GutterAngled"
      };
    case "Gutter lower" :
      return {
        TAG: "PlaceClassGutter",
        _0: "GutterLower"
      };
    case "Gutter upper" :
      return {
        TAG: "PlaceClassGutter",
        _0: "GutterUpper"
      };
    case "Handlebar suspension" :
      return "PlaceClassHandlebarSuspension";
    case "Other" :
      return "PlaceClassOther";
    case "Staple" :
      return "PlaceClassStapleRack";
    case "Unclassified" :
      return "PlaceClassUnclassified";
    case "Vertical" :
      return "PlaceClassVertical";
    case "Wheel clamp" :
      return "PlaceClassWheelClamp";
    default:
      return;
  }
}

let stringCodec = {
  toString: stringCodec_toString,
  fromString: stringCodec_fromString
};

let jsonCodec$3 = LumiJzon.taggedVariantOptionalContents(x => {
  if (typeof x === "object") {
    if (x.TAG === "PlaceClassGround") {
      return [
        "PlaceClassGround",
        Jzon.encodeWith(x._0, jsonCodec$1)
      ];
    } else {
      return [
        "PlaceClassGutter",
        Jzon.encodeWith(x._0, jsonCodec$2)
      ];
    }
  }
  switch (x) {
    case "PlaceClassUnclassified" :
      return [
        "PlaceClassUnclassified",
        undefined
      ];
    case "PlaceClassOther" :
      return [
        "PlaceClassOther",
        undefined
      ];
    case "PlaceClassWheelClamp" :
      return [
        "PlaceClassWheelClamp",
        undefined
      ];
    case "PlaceClassStapleRack" :
      return [
        "PlaceClassStapleRack",
        undefined
      ];
    case "PlaceClassVertical" :
      return [
        "PlaceClassVertical",
        undefined
      ];
    case "PlaceClassHandlebarSuspension" :
      return [
        "PlaceClassHandlebarSuspension",
        undefined
      ];
  }
}, param => {
  let maybeContents = param[1];
  let tag = param[0];
  switch (tag) {
    case "PlaceClassGround" :
      if (maybeContents !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(maybeContents, jsonCodec$1), res => ({
          TAG: "PlaceClassGround",
          _0: res
        }));
      }
      break;
    case "PlaceClassGutter" :
      if (maybeContents !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(maybeContents, jsonCodec$2), res => ({
          TAG: "PlaceClassGutter",
          _0: res
        }));
      }
      break;
    case "PlaceClassHandlebarSuspension" :
      return {
        TAG: "Ok",
        _0: "PlaceClassHandlebarSuspension"
      };
    case "PlaceClassOther" :
      return {
        TAG: "Ok",
        _0: "PlaceClassOther"
      };
    case "PlaceClassStapleRack" :
      return {
        TAG: "Ok",
        _0: "PlaceClassStapleRack"
      };
    case "PlaceClassUnclassified" :
      return {
        TAG: "Ok",
        _0: "PlaceClassUnclassified"
      };
    case "PlaceClassVertical" :
      return {
        TAG: "Ok",
        _0: "PlaceClassVertical"
      };
    case "PlaceClassWheelClamp" :
      return {
        TAG: "Ok",
        _0: "PlaceClassWheelClamp"
      };
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonValue",
      VAL: [
        [],
        tag
      ]
    }
  };
}, undefined, undefined);

function PlaceClass$PlaceClass$Icon(props) {
  let placeClass = props.placeClass;
  if (typeof placeClass !== "object") {
    switch (placeClass) {
      case "PlaceClassUnclassified" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "question"
        });
      case "PlaceClassOther" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "ellipsis"
        });
      case "PlaceClassWheelClamp" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "wrench"
        });
      case "PlaceClassStapleRack" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "u",
          rotate: 180
        });
      case "PlaceClassVertical" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "bicycle",
          rotate: -90
        });
      case "PlaceClassHandlebarSuspension" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "bicycle",
          rotate: -22.5
        });
    }
  } else if (placeClass.TAG === "PlaceClassGround") {
    switch (placeClass._0) {
      case "VehicleBicycle" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "bicycle"
        });
      case "VehicleScooter" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "motorcycle"
        });
      case "VehicleCar" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "car"
        });
    }
  } else {
    switch (placeClass._0) {
      case "GutterUpper" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "right-from-bracket",
          rotate: -90
        });
      case "GutterLower" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "right-to-bracket",
          rotate: 90
        });
      case "GutterAngled" :
        return JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "grip-lines",
          rotate: -22.5
        });
    }
  }
}

let Icon = {
  make: PlaceClass$PlaceClass$Icon
};

function translate(locale, entry) {
  switch (locale) {
    case "ENG" :
      if (typeof entry !== "object") {
        switch (entry) {
          case "PlaceClassUnclassified" :
            return "Unclassified";
          case "PlaceClassOther" :
            return "Other";
          case "PlaceClassWheelClamp" :
            return "Wheel clamp";
          case "PlaceClassStapleRack" :
            return "Staple rack";
          case "PlaceClassVertical" :
            return "Vertical";
          case "PlaceClassHandlebarSuspension" :
            return "Handlebar suspension";
        }
      } else if (entry.TAG === "PlaceClassGround") {
        switch (entry._0) {
          case "VehicleBicycle" :
            return "Ground bicycle";
          case "VehicleScooter" :
            return "Ground scooter";
          case "VehicleCar" :
            return "Ground car";
        }
      } else {
        switch (entry._0) {
          case "GutterUpper" :
            return "Gutter upper";
          case "GutterLower" :
            return "Gutter lower";
          case "GutterAngled" :
            return "Gutter angled";
        }
      }
    case "NLD" :
      if (typeof entry !== "object") {
        switch (entry) {
          case "PlaceClassUnclassified" :
            return "Niet geclassificeerd";
          case "PlaceClassOther" :
            return "Anders";
          case "PlaceClassWheelClamp" :
            return "Wielklem";
          case "PlaceClassStapleRack" :
            return "Nietje";
          case "PlaceClassVertical" :
            return "Verticaal";
          case "PlaceClassHandlebarSuspension" :
            return "Opgehangen aan stuur";
        }
      } else if (entry.TAG === "PlaceClassGround") {
        switch (entry._0) {
          case "VehicleBicycle" :
            return "Grond fiets";
          case "VehicleScooter" :
            return "Grond step";
          case "VehicleCar" :
            return "Groud auto";
        }
      } else {
        switch (entry._0) {
          case "GutterUpper" :
            return "Gootje hoog";
          case "GutterLower" :
            return "Gootje laag";
          case "GutterAngled" :
            return "Gootje schuin";
        }
      }
    default:
      return;
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

function toClassName(placeClass) {
  if (typeof placeClass !== "object") {
    switch (placeClass) {
      case "PlaceClassUnclassified" :
        return "place-class-unclassified";
      case "PlaceClassOther" :
        return "place-class-other";
      case "PlaceClassWheelClamp" :
        return "place-class-wheel-clamp";
      case "PlaceClassStapleRack" :
        return "place-class-staple-rack";
      case "PlaceClassVertical" :
        return "place-class-vertical";
      case "PlaceClassHandlebarSuspension" :
        return "place-class-handlebar-suspension";
    }
  } else if (placeClass.TAG === "PlaceClassGround") {
    switch (placeClass._0) {
      case "VehicleBicycle" :
        return "place-class-ground-bicycle";
      case "VehicleScooter" :
        return "place-class-ground-scooter";
      case "VehicleCar" :
        return "place-class-ground-car";
    }
  } else {
    switch (placeClass._0) {
      case "GutterUpper" :
        return "place-class-gutter-upper";
      case "GutterLower" :
        return "place-class-gutter-lower";
      case "GutterAngled" :
        return "place-class-gutter-angled";
    }
  }
}

function axesModelDimensions(placeClass) {
  if (typeof placeClass !== "object") {
    return {
      widthFront: 0.500,
      widthBack: 0.400,
      heightFront: 0.750,
      heightBack: 0.600,
      baseFrontExtra: 0.400,
      baseBackExtra: 0.000
    };
  }
  if (placeClass.TAG !== "PlaceClassGround") {
    return {
      widthFront: 0.500,
      widthBack: 0.400,
      heightFront: 0.750,
      heightBack: 0.600,
      baseFrontExtra: 0.400,
      baseBackExtra: 0.000
    };
  }
  switch (placeClass._0) {
    case "VehicleBicycle" :
    case "VehicleScooter" :
      return {
        widthFront: 0.500,
        widthBack: 0.400,
        heightFront: 0.750,
        heightBack: 0.600,
        baseFrontExtra: 0.400,
        baseBackExtra: 0.000
      };
    case "VehicleCar" :
      return {
        widthFront: 2.000,
        widthBack: 1.500,
        heightFront: 0.400,
        heightBack: 0.200,
        baseFrontExtra: 0.000,
        baseBackExtra: 0.500
      };
  }
}

function quadrilateralModelHeight(placeClass) {
  if (typeof placeClass !== "object") {
    return 1.000;
  }
  if (placeClass.TAG !== "PlaceClassGround") {
    return 1.000;
  }
  switch (placeClass._0) {
    case "VehicleBicycle" :
    case "VehicleScooter" :
      return 1.000;
    case "VehicleCar" :
      return 1.500;
  }
}

let PlaceClass = {
  values: values,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$3,
  Icon: Icon,
  T: T,
  toClassName: toClassName,
  axesModelDimensions: axesModelDimensions,
  quadrilateralModelHeight: quadrilateralModelHeight
};

export {
  AxesModelDimensions,
  VehicleClass,
  GutterClass,
  PlaceClass,
}
/* jsonCodec Not a pure module */
